import { createApi } from '@reduxjs/toolkit/query/react';
import { ReducerPaths } from '../../constants/reducerPaths';
import { baseQuery } from '../../utils/baseQuery';
import { getAllTenants } from './queries';

export const tenantApi = createApi({
  reducerPath: ReducerPaths.TENANT,
  baseQuery,
  tagTypes: ['tenant'],
  endpoints: (builder) => ({
    getAllTenants: getAllTenants(builder),
  }),
});

export const { useGetAllTenantsQuery } = tenantApi;
